"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_1 = require("./styled");

exports.TileButton = function (props) {
  var text = props.text,
      isSelected = props.isSelected,
      action = props.action,
      activeBreakpoint = props.activeBreakpoint,
      accessibilityLabel = props.accessibilityLabel,
      selectedAccessibilityLabel = props.selectedAccessibilityLabel; // Determine which accessibility label to use

  var computedAccessibilityLabel = isSelected ? selectedAccessibilityLabel || accessibilityLabel : accessibilityLabel;
  return react_1.default.createElement(styled_1.ButtonContainer, {
    activeBreakpoint: activeBreakpoint,
    isSelected: isSelected,
    onPress: action,
    accessibilityLabel: computedAccessibilityLabel
  }, react_1.default.createElement(react_native_1.View, null, react_1.default.createElement(styled_1.ButtonText, {
    isSelected: isSelected
  }, text)), react_1.default.createElement(styled_1.CircleActive, null, isSelected && react_1.default.createElement(styled_1.InnerCircle, null)));
};